export function hasFeat(feature: string): boolean {
  const feats = window.env.IAM.FEAT as Record<string, boolean>;
  return feats[feature] || false;
}
